var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-text',{staticClass:"uni-icons",class:['uniui-' + _vm.type, _vm.customPrefix, _vm.customPrefix ? _vm.type : ''],style:(_vm.styleObj),on:{"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm._onClick).apply(void 0, arguments)
}}},[_vm._t("default")],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }